import ParentView from "../../Views/PrarentView/ParentView";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { uid } from "../../utils/HelperFunctions";
import { updateTempCartPayloadAction } from "../../store/actions/cartAction";
import { metaTempleImg, orderType, packageType } from "../../utils/Constants";
import {
  getPujaPackageDetailsAction,
  getPujaPackagePriceAction,
  getTopFivePujaFeedBack,
} from "../../store/actions/pujaAction";
import HelmetComponent from "../../components/Shared/HelmetComponent";
import PujaPackageInfoView from "../../Views/PujaPackage/PujaPackageInfoView";

function PujaPackageInfoscreen(props: any) {
  const location = useLocation();
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const [pujaDetails, setPujaDetails] = useState<any>(null);
  const [popupPujaAlreadyAdded, setPopupPujaAlreadyAdded] = useState(false);
  const [itemAddLimitPopUp, setItemAddLimitPopUp] = useState(false);
  const [pujaPriceInfo, setPujaPriceInfo] = useState<any>(null);
  const [userReview, setUserReview] = useState<any>([]);
  const [selectedPlan, setSelectedPlan] = useState<any>(null);
  const { selectedTempleDetails, benefitsList } = useSelector(
    (state: any) => state.temple
  );
  const { pujaVideos} = useSelector((state:any)=>state.dashboard)
  const { cartInfo } = useSelector((state: any) => state.cart);
  const templeAndPujaInfoPath = location.pathname;
  const queryParams = new URLSearchParams(location.search);
  // const templeNameKey = queryParams.get("templeNameKey");
  const pujaNameKey = queryParams.get("pujaNameKey");
  const priceConversionState = useSelector(
    (state: any) => state.priceConversion
  );
  const {
    rate = 1,
    currencySymbols = "₹",
    isOverseas = false,
  } = priceConversionState.priceConversionRate || {};
  const templeNameKey = Object.values(pujaDetails?.templeList || {}).map(
    (temple: any) => temple.nameKey
  );

  const [pujaPackagePrice, setPujaPackagePrice] = useState<any>(null);
  const [pujaSubscriptionPrice, setPujaSubscriptionPrice] = useState<any>(null);
  useEffect(() => {
    if (selectedTempleDetails?.nameKey) {
      dispatch(
        getTopFivePujaFeedBack(orderType?.puja, selectedTempleDetails?.nameKey)
      )
        .then((res: any) => {
          if (res) {
            setUserReview(res);
          }
        })
        .catch((err: any) => {});
    }
  }, [selectedTempleDetails?.nameKey]);

  useEffect(() => {
    if (pujaNameKey) {
      const fetchDetails = async () => {
        try {
          const data = await dispatch(getPujaPackageDetailsAction(pujaNameKey));
          setPujaDetails(data);
        } catch (err) {
          navigate("/pujas");
        }
      };
      fetchDetails();
    }
  }, [pujaNameKey, dispatch]);

  useEffect(() => {
    const getPriceFRomServer = async () => {
      if (pujaDetails?.id && pujaDetails?.priceBreakupV1) {
        try {
          const packagePrice = await dispatch(
            getPujaPackagePriceAction(
              pujaDetails.priceBreakupV1,
              isOverseas,
              rate,
              false
            )
          );

          setPujaPackagePrice(packagePrice);
          setPujaPriceInfo(packagePrice);
          if (
            Array.isArray(pujaDetails?.subscriptions) &&
            pujaDetails.subscriptions.length > 0
          ) {
            const subscriptionPrices = await Promise.all(
              pujaDetails?.subscriptions.map((sub: any) =>
                dispatch(
                  getPujaPackagePriceAction(
                    sub.priceBreakupV1,
                    isOverseas,
                    rate,
                    false
                  )
                )
              )
            );

            setPujaSubscriptionPrice(subscriptionPrices);
          }
        } catch (error) {
          console.error("Error fetching price:", error);
        }
      }
    };

    getPriceFRomServer();
  }, [rate, isOverseas, pujaDetails?.id]);

  useEffect(() => {
    if (
      pujaDetails?.isOnlySubscription === true &&
      pujaDetails?.isSubscriptionEnable === true &&
      Array.isArray(pujaDetails?.subscriptions) &&
      pujaDetails.subscriptions.length > 0
    ) {
      const subPlan = pujaDetails.subscriptions[0];
      const subPriceInfo = pujaSubscriptionPrice?.[0] ?? {};
      setSelectedPlan({ ...subPlan, ...subPriceInfo, id: subPlan.id });
      setPujaPriceInfo(subPriceInfo);
    }
  }, [
    pujaDetails?.isOnlySubscription,
    pujaDetails?.isSubscriptionEnable,
    pujaDetails?.subscriptions,
    pujaSubscriptionPrice,
  ]);

  const preprocessingAndProceedToAddmemberScreen = async () => {
    // Open pupup for limiting popup and return from there
    if (
      (cartInfo && cartInfo.length === 6) ||
      (cartInfo && cartInfo.length > 6)
    ) {
      setItemAddLimitPopUp(true);
      return;
    }
    const id = uid();
    let cartDataPayload: any = {
      id: id,
      cartId: id,
      membersData: [],
      // bookedForDate: {
      //   pujaDate: "2025-11-18",
      //   pujaTime: "10:30AM",
      // },
      bookedForDate: null,
      pujaDetails: {
        pujaId: pujaDetails?.pujaId ?? pujaDetails?.id,
        pujaName: pujaDetails?.pujaName,
        pujaNameKey: pujaDetails?.pujaNameKey,
        pujaBg: pujaDetails?.pujaBg,
        packageItems: pujaDetails?.packageItems ?? null,
        templeList: pujaDetails?.templeList ?? null,
        type: pujaDetails?.type ?? packageType.puja,
        packageDescription: pujaDetails?.packageDescription ?? null,
        packageDetailsImage: pujaDetails?.packageDetailsImage ?? null,
        priceBreakupV1: pujaDetails?.priceBreakupV1 ?? null,
        subscriptions: pujaDetails?.subscriptions ?? [],
      },
      isSubscribed: selectedPlan?.id ? true : false,
      ...(selectedPlan?.id && { subscriptionId: selectedPlan?.id }),
      selectedPujaPackage: pujaDetails?.multiplePujaDetails?.length
        ? pujaDetails?.multiplePujaDetails[0]
        : {
            packageId: uid(),
            maxMemberAllowed: "1",
            isMostPopular: false,
          },
      orderType: orderType.pujaPackage,
      isPrasad: false,
      tempPriceInfo: {
        finalPrice: pujaPriceInfo?.finalPrice,
      },
    };
    dispatch(updateTempCartPayloadAction(cartDataPayload)).then(() => {
      navigate(`/checkoutV2/addDevotee`);
    });
  };

  const hostname =
    window.location.hostname === "localhost"
      ? "http://localhost:3000"
      : "https://" + window.location.hostname;

  const onClickAddPuja = (_pujaDetails: any) => {
    const pujaDetails = _pujaDetails?.pujaDetails ?? null;
    navigate(
      `/templePujaInfo?templeNameKey=${pujaDetails.nameKey}&pujaNameKey=${pujaDetails?.pujaNameKey}`
    );
  };

  const handlePujaPlanChange = (id: string, priceInfo: any) => {
    if (id === "") {
      setSelectedPlan(null);
      setPujaPriceInfo(pujaPackagePrice);
      return;
    }
    // if (selectedPlan?.id === id) {
    //   setSelectedPlan(null);
    // }
    else {
      const selected = pujaDetails?.subscriptions?.find(
        (p: any) => p.id === id
      );
      setSelectedPlan({ ...selected, ...priceInfo, id });
      setPujaPriceInfo(priceInfo);
    }
  };

  const navigateToPujaStepsView = () => {
    navigate(`/pujaSteps?pujaNameKey=${pujaNameKey}`);
  };

  const navigateToSeeVideoView = () => {
    navigate("/pujaVideo");
  };
  return (
    <ParentView>
      <HelmetComponent
        metaData={{
          title:
            pujaDetails?.pujaMetaData?.metaTitle ??
            pujaDetails?.pujaName ??
            "Temple" + " | TempleDekho",
          keywords: pujaDetails?.pujaMetaData?.metaKeys ?? null,
          robots: "index, follow",
          description:
            pujaDetails?.pujaMetaData?.metaDescription ??
            pujaDetails?.pujaDescription,
          url: hostname + templeAndPujaInfoPath,
          imageUrl: pujaDetails?.pujaBg?.uri ?? metaTempleImg,
        }}
      >
        <PujaPackageInfoView
          cartInfo={cartInfo}
          pujaDetails={pujaDetails}
          selectedTempleDetails={selectedTempleDetails}
          preprocessingAndProceedToAddmemberScreen={
            preprocessingAndProceedToAddmemberScreen
          }
          benefitsList={benefitsList}
          popupPujaAlreadyAdded={popupPujaAlreadyAdded}
          setPopupPujaAlreadyAdded={setPopupPujaAlreadyAdded}
          navigateToSeeVideoView={navigateToSeeVideoView}
          pujaPriceInfo={pujaPriceInfo}
          overSeasRate={rate}
          currencySymbols={currencySymbols}
          isOverseas={isOverseas}
          isCountryDisabledForBooking={
            priceConversionState?.isCountryDisabled ?? false
          }
          userReview={userReview}
          navigateToPujaStepsView={navigateToPujaStepsView}
          itemAddLimitPopUp={itemAddLimitPopUp}
          setItemAddLimitPopUp={setItemAddLimitPopUp}
          pujaPackagePrice={pujaPackagePrice}
          pujaSubscriptionPrice={pujaSubscriptionPrice}
          onClickAddPuja={onClickAddPuja}
          selectedPlan={selectedPlan}
          handlePujaPlanChange={handlePujaPlanChange}
          isOnlySubscriptionEnable={
            pujaDetails?.isOnlySubscription === true &&
            pujaDetails?.isSubscriptionEnable === true
          }
          pujaPackagePreviewVideos={pujaVideos|| []}
        />
      </HelmetComponent>
    </ParentView>
  );
}

export default PujaPackageInfoscreen;
